<template>
<div>
  <div class="trainer" v-show="!reaction">
    <div class="trainer__header">
      <div class="train__info" v-show="active">
        <div class="train__item" uk-tooltip="Ошибок сделано">
          <div class="train__ico train__ico--2"></div>
          <small>Ошибок:</small>
          {{ errors }}
        </div>
        <div class="train__item" v-if="$route.params.isHomework" uk-tooltip="Выполнено упражнений">
          <div class="train__ico train__ico--4"></div>
          <small>Выполнено:</small>
          <div class="train__nowrap">{{ $route.params.total }} из {{ $route.params.qnt }}</div>
        </div>
        <div class="train__item" uk-tooltip="Времени прошло">
          <div class="train__ico train__ico--3"></div>
          <div>
            <small>Времени прошло:</small>
            <!--<br class="uk-visible@s">-->
            {{ timer.minutes }} мин. {{ timer.seconds }} сек.
          </div>
        </div>
      </div>

      <div class="game__name">
        <div class="menu-settings" v-show="!params.finish">
          <div class="game__settings" @click="showsettings" v-show="user.role.code !== 'student'"></div>
          <span>{{ params.text.title ? params.text.title : 'ТЕКСТ' }}</span>          
        </div>
        <div v-if="reading" class="text-settings">
          <div class="font_size" v-if="reading">
            <button uk-tooltip="уменьшить шрифт" @click="changeFontSize('-')">Аа-</button>
            <button uk-tooltip="увеличить шрифт" @click="changeFontSize('+')">Аа+</button>         
          </div>
          <div class="text-width">
            <range-slider
              min="40"
              max="90"
              step="5"
              v-model="textWidth">
            </range-slider>
            <span>  ⇔ {{textWidth}} %</span>
          </div>
        </div>        
      </div>

      <a class="trainer__stop-btn" href="#" @click.prevent="onStopTrainer">Остановить</a>
    </div>

    <div class="trainer__body">
      <a 
        class="start-disappear" 
        href="#" 
        @click.prevent="disappearing_text" 
        v-if="active && !disappearingStarted && params.mode === 'disappearing_text'"
      >
        Старт
      </a>
      <div class="texts__container" :style="`width: ${textWidth}%`">
        <div id="text_content" v-show="reading" class="text_content texts__content" v-html="printed_text">
        </div>
        <!-- КНОПКА НАЧАЛА ЧТЕНИЯ-->
        <div class="texts__intro" v-if="!reading && !finish">
          Нажимай на кнопку чтобы начать чтение!
          <button class="uk-button uk-button-primary" @click="letStart">Начать</button>
        </div>
      </div>

      <a class="stop-btn" href="#" @click.prevent="onLetStop" v-if="reading && !params.finish">Закончить чтение</a>

      <!-- ФИНИШ -->
      <div v-if="params.finish">
        <h2>Отлично! Молодец!</h2>

        <quiz :items="params.text.questions" v-if="hasQuestions" @hasQuestions="pre_finish = true" @endQuestions="endQuestions"></quiz>

        <p class="scores" v-if="!pre_finish">И ты зарабатываешь
          <strong>{{ scores }}</strong> {{ $root.getNoun(scores, 'балл', 'балла', 'баллов') }}!</p>
        <div v-if="!pre_finish" class="trainer__buttons">
          <button class="uk-button uk-button-primary" @click="letStart" v-if="isHw && !checkFinishHomework()">Повторить!</button>
          <button class="uk-button uk-button-primary" @click="onStopTrainer" v-else>Закончить</button>
        </div>
      </div>

      <div class="texts__settings" v-if="settings">
        <div class="texts__closesettings" @click="showsettings"><span uk-icon="close"></span></div>
        <settings :ingame="true"></settings>
      </div>
    </div>
  </div>

  <div class="wh-block wh-block--reaction" v-if="reaction">
    <div class="reaction">
      <!--<video loop muted preload="auto" autoplay>-->
      <video disableRemotePlayback preload="auto" autoplay @ended="stopReaction">
        <source type="video/mp4" :src="'/storage/app/media/reactions/' + reaction_file" id="mp4">
      </video>
    </div>
  </div>
</div>
</template>

<script>
import {
  mix
} from "./../mixin";
import {
  texts_mixin
} from "./texts_mixin";
import {
  modes_mixin
} from './modes_mixin'
import settings from "./components/Settings";
import quiz from "../speedtest/quiz";

import mode_params from "./mode_params";
import RangeSlider from 'vue-range-slider'

export default {
  name: "game",
  mixins: [
    mix, texts_mixin, modes_mixin
  ],
  components: {
    mode_params,
    quiz,
    settings,
    RangeSlider
  },
  data() {
    return {
      // matrius
      quality: null,

      textWidth: 80,
      pre_finish: false,
      settings: false,
      cifs: '',
      shuffle: '',
      active: false,
      step: 0,
      errors: 0,
      nextCif: '',
      currentCif: '',
      reaction: false,
      scores: 0,
    }
  },
  computed: {
    // ...mapState({
    //   params: state => state.train.texts_params
    // }),
    finish() {
      return this.params.finish
    },
    user() {
      return this.$store.state.user;
    },
    hasQuestions() {
      return !_.isEmpty(this.params.text.questions);
    }
  },
  inject: ['http', 'params'],
  methods: {
    changeFontSize(val) {
      let step = 0.1;
      let cnt = document.getElementsByClassName('texts__content');
      let current_fz = cnt[0].style.fontSize;
      let fz = current_fz ? parseFloat(current_fz) : 1;
      let result;
      if (val === '+') {
        result = fz + step;
      } else {
        result = fz - step;
      }
      cnt[0].style.fontSize = result + 'em';

      // Проверка если вдруг что
      this.checkTransformation();
    },
    async checkTransformation() {
      if (this.params.mode === 'curtain') {
        await this.makeNormalText('nrm');
        this.makeCurtain();

      }
    },
    endQuestions(quality) {
      // matruis
      this.quality = quality

      console.log('end questions', quality);
      this.pre_finish = false;
      this.addScores(quality);
      this.makeStats();
    },
    showsettings() {
      console.log('show settings');
      this.settings = !this.settings;
    },
    stopGame() {
      this.active = false;
      this.$parent.commitVal(true, 'finish');
      if (!this.hasQuestions) {
        this.addScores();
        this.makeStats();
      }
    },

    startGame() {
      this.scroll();
      this.params.finish = false;
      this.settings = false;
      this.step = 0;
      this.errors = 0;
      this.startTimer();
      this.active = true;
    },
    letStart() {
      this.$emit('start app');
      this.reading = true;
      //this.checkMetronom();
      this.startGame();
    },
    onLetStop() {
      this.$emit('finish app');
      this.reading = false;
      //this.checkMetronom();
      this.stopGame();
    },
    addScores(quality = 0) {
      let sum = 0;
      /*let scores = (this.params.size * this.params.size) * (1 - (this.errors / 10));

      sum = Math.ceil(scores);

      */
      if (this.params.text.questions && this.params.text.questions.length > 0) {
        console.log('есть вопросы', this.params.text.words_count, quality);
        if (quality === 0) {
          sum = 0;
        } else {
          let words = this.params.text.words_count
          let minTime = words * 60
          let totalTime = this.timer.total_ms;
          let time = totalTime < minTime ? minTime : totalTime
          let coefficient = words / 100

          sum = Math.ceil((words / (time / 1000)) * (quality / 100) + coefficient);
        }
      } else {
        console.log('нет вопросов');
        sum = Math.ceil(this.params.text.words_count / 100);
      }

      if (this.$route.params.isHomework) {
        sum = Math.ceil(sum * this.$store.state.hw_coefficient);
      }

      this.checkScoreStatus(sum);
      this.scores = sum;

      this.$store.commit('changeUserScores', sum);
      console.log('Баллов заработано', sum);
    },
    makeStats() {
      console.log("Make stats");
      if (this.user.role.code === 'student') {
        let path = this.$route.params.is_matrius ? 'onSaveMatriusAnswer' : 'onSaveStats'
        console.log('Бережно сохраняем статистику');
        let hasActive = this.active;
        if (!hasActive) {
          let time = this.timer;
          let train_params = this.params;
          if (train_params.text) {
            //train_params.text_title = train_params.text.title;
            //train_params.text = '';
          }
          let stats = {
            time: time,
            hasActive: hasActive,
            user_id: this.$store.state.user.id,
            trainer: this.$store.state.current_trainer.id,
            scores: this.scores,
            train_params: {}
          }

          stats = this.checkHomework(stats);

          if (this.$route.params.is_matrius) {
            stats.student_task_id = this.$route.params.student_task_id
            stats.quality = this.quality
            stats.qnt = 1
          }
          let data = {
            'stat': stats
          }
          console.log(data)
          this.http.post(path, data).then((res) => {
            this.stat_id = res.id;
            this.checkCoins(res.data);

            if (this.$route.params.is_matrius && res.data.is_done) {
              swal('Успешно!', res.data.message, 'success')
            }
          })
          .catch(e => swal('Что-то пошло не так', '' + e, 'error'))
        }
      } else {
        console.log('Учителей в статистику не заносим! Понятно?!');
      }
    },
    /** РЕАКЦИИ */
    startReaction() {
      if (this.params.show_reactions) {
        let type = (this.errors === 0 ? 'react_plus' : 'react_minus');
        this.reaction_file = this.checkReaction(type);
        this.reaction = true;
      }
    },
    stopReaction() {
      this.reaction = false;
      let app = this;
      setTimeout(function () {
        app.scroll();
        $('#repeat-' + app.inkey).focus();
      }, 100);
    },
    scroll() {
      UIkit.scroll('.headline2').scrollTo('.game');
    }
  },
  mounted() {
    this.fixMenu()
  },
  beforeDestroy() {
    this.$emit('finish app');
    //this.makeStats();
    this.$parent.commitVal(false, 'start')
  }
}
</script>

<style lang="scss" scoped>
.game__name {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
}

.menu-settings {
  display: flex;
  align-items: center;

  & span {
    margin-left: 10px;
  }
}

.stop-btn {
  align-self: center;
  margin-top: 20px;
  margin-bottom: 40px;
}

.font_size {
  margin-right: 10px;
}

.back-btn {
  margin-top: 10px;
}

.trainer__body {
  text-align: center;
}

.trainer__buttons {
  margin-top: 20px;
}
.text-settings {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;

  & div {
    margin-top: 10px;
  }
}

.text-width {
  display: flex;
  align-items: center;
  padding: 5px;

  & span {
    font-size: 14px;
    margin-left: 5px;
  }
}

.start-disappear {
  margin-bottom: 20px;
}
</style>
